export default class DateFormat {
    constructor(time) {
        this.time = time ? time : Date.now()
        this.date = new Date(this.time)
    }

    format(format) {
        const y = this.date.getFullYear().toString()
        const m = this.date.getMonth() + 1
        const d = this.date.getDate()
        const h = this.date.getHours()
        const mm = this.date.getMinutes()

        return format.replace(
            /yyyy|YYYY|yy|YY|MM|M|dd|DD|d|D|hh|HH|h|H|mm|m/g,
            function (str) {
                switch (str) {
                    case "YYYY":
                    case "yyyy": return y

                    case "yy":
                    case "YY": return y.substring(2, 4)

                    case "MM": return m <= 9 ? '0' + m : m
                    case "M": return m

                    case "dd":
                    case "DD": return d <= 9 ? '0' + d : d

                    case "d":
                    case "D": return d

                    case "hh":
                    case "HH": return h <= 9 ? '0' + h : h

                    case "h":
                    case "H": return h

                    case "mm": return mm <= 9 ? '0' + mm : mm
                    case "m": return mm
                    default: return str
                }
            }
        )
    }
}
